import React from 'react';
import { DyteAudioVisualizer } from '@dytesdk/react-ui-kit';
import { useDyteMeeting, useDyteSelector } from '@dytesdk/react-web-core';

import clsx from 'clsx';
import { Avatar, Typography } from '@mui/material';
import { useSelector } from 'react-redux';

export default function Stage() {
  const { meeting } = useDyteMeeting();
  const { callerImg } = useSelector((state: any) => state.meeting);

  const activeParticipants = useDyteSelector((meeting) =>
    meeting.participants.active.toArray()
  );

  const joinedParticipants = useDyteSelector((meeting) =>
    meeting.participants.joined.toArray()
  );

  const participants = [
    ...activeParticipants,
    ...joinedParticipants.filter((p) => !activeParticipants.includes(p)),
    meeting.self,
  ];

  return (
    <main className="flex-1 relative flex flex-wrap content-center justify-center gap-4 p-6 roombg">
      {participants.map((participant) => {
        return (
          <div
            className={clsx(
              'relative min-w-[180px] flex flex-col items-center justify-center gap-2 bg-zinc-100 border-2 p-6 pb-2 rounded-xl break-all',
              participant.audioEnabled &&
                'border-blue-500 shadow-lg shadow-blue-100'
            )}
            key={participant.id}
          >
            <Avatar src={participant.id === meeting.self.id? participant : callerImg} sx={{ width: 56, height: 56 }} />
            <div className="flex items-center gap-0.5">
              <DyteAudioVisualizer
                participant={participant}
                size="md"
                className="absolute top-2 left-2"
              />
              <div>
                <Typography sx={{ color: 'dark.main' }}>{participant.name}</Typography>
                <Typography sx={{ color: 'dark.main' }}>{participant.id === meeting.self.id ? ' (you)' : null}</Typography>
              </div>
            </div>
          </div>
        );
      })}
    </main>
  );
}
